// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ReactToRactiveAdapter } from '../ReactToRactiveAdapter';
import { OvernightExecutionControl } from '../ReactControls/elements/OvernightExecutionControl';
export class OvernightExecutionControlRactive extends ReactToRactiveAdapter {
    constructor() {
        super();
    }
}
ReactToRactiveAdapter.extendWith(OvernightExecutionControlRactive, {
    template: '<div class="overnight-execution-control-wrapper"></div>',
    mountContainer: '.overnight-execution-control-wrapper',
    reactComponent: OvernightExecutionControl,
    data: function () {
        return {
            props: {}
        };
    }
});
